// extracted by css-extract-rspack-plugin
export default {"highlightedBg":"footer-fragment__Footer_highlightedBg__vmt5o"};